// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bMessageSettingsForm {
  margin-top: 20px;
}

.bMessageTextFormEmailEditor {
  margin-top: 10px;
  padding: 10px;
  height: auto;
}

.bMessageTextFormPushEditor,
.bMessageTextFormSmsEditor {
  margin-top: 10px;
  padding: 10px;
  height: 633px;
}

.eMessageTextFormSmsEditorCounters {
  margin-top: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminSUView/Tournaments/MessageSettingsForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".bMessageSettingsForm {\n  margin-top: 20px;\n}\n\n.bMessageTextFormEmailEditor {\n  margin-top: 10px;\n  padding: 10px;\n  height: auto;\n}\n\n.bMessageTextFormPushEditor,\n.bMessageTextFormSmsEditor {\n  margin-top: 10px;\n  padding: 10px;\n  height: 633px;\n}\n\n.eMessageTextFormSmsEditorCounters {\n  margin-top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
